import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row align-items-end" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "input-group mb-5" }
const _hoisted_5 = { class: "input-group-append" }
const _hoisted_6 = {
  class: "el-input__inner",
  id: "basic-addon1"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header card-p border-0 pt-0" }
const _hoisted_13 = { class: "card-title align-items-start flex-column" }
const _hoisted_14 = { class: "card-label fw-bolder fs-3" }
const _hoisted_15 = { class: "card-body p-0" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_18 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_19 = { class: "menu-item-wrapper" }
const _hoisted_20 = { class: "menu-item" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_22 = { class: "menu-item" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductSmartUnits = _resolveComponent("ProductSmartUnits")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.wmsManagesProducts)
      ? (_openBlock(), _createBlock(_component_ProductSmartUnits, {
          key: 0,
          baseUnit: _ctx.baseUnit,
          productUnits: _ctx.productUnits
        }, null, 8, ["baseUnit", "productUnits"]))
      : _createCommentVNode("", true),
    (!_ctx.readOnly)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_Select, {
                name: "dimension",
                target: "dimension",
                label: `${_ctx.$t('message.DIMENSION')} ${_ctx.$t('message.NAME')} `,
                dimension: _ctx.dimension,
                "onUpdate:dimension": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dimension = $event)),
                selectData: _ctx.dimensions,
                value: _ctx.dimension,
                "call-emit": true,
                clearable: true,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeDimension(_ctx.dimension)))
              }, null, 8, ["label", "dimension", "selectData", "value"])
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control el-input__inner py-0",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.value = $event)),
                  placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.VALUE')} `
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.value]
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.unit), 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                type: "primary",
                class: "mt-2 btn-custom",
                style: {"float":"right"},
                disabled: _ctx.dimensionButton,
                onClick: _ctx.addDimension
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dimensionId == undefined ? _ctx.$t("message.SAVE") : _ctx.$t("message.UPDATE")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("h3", _hoisted_13, [
              _createVNode("span", _hoisted_14, _toDisplayString(`${_ctx.$t("message.DIMENSIONS")} ${_ctx.$t("message.LIST")}`), 1)
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_Table, {
                columns: _ctx.readOnly ? _ctx.columns.filter(column => column.key != 'actions') : _ctx.columns,
                rows: _ctx.dimensionsList,
                padding: 5
              }, {
                "cell-actions": _withCtx(({index:index}) => [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("a", {
                          onClick: ($event: any) => (_ctx.handleEdit(index)),
                          class: "menu-link me-1"
                        }, [
                          _hoisted_21,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("message.EDIT")), 1)
                        ], 8, ["onClick"])
                      ]),
                      _createVNode("div", _hoisted_22, [
                        _createVNode("a", {
                          onClick: ($event: any) => (_ctx.handleDelete(index)),
                          class: "menu-link me-1"
                        }, [
                          _hoisted_23,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("message.DELETE")), 1)
                        ], 8, ["onClick"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}